import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { ContentModal, ContentWrapperModal, Close } from './styles';
import { Icon } from '../Icon';
const DropModal = ({ children, onClick, colorButtonClose }, ref) => {
    const [opened, setOpened] = useState(false);
    const handleOpen = () => {
        setOpened(true);
    };
    const handleClose = () => {
        setOpened(false);
    };
    useImperativeHandle(ref, () => ({
        handleOpen,
        handleClose,
    }));
    const handleClick = async () => {
        try {
            await onClick?.();
            handleClose();
        }
        catch (error) {
            console.log(error);
        }
    };
    return (_jsx(Dialog.Root, { open: opened, children: _jsx(Dialog.Portal, { children: _jsxs(ContentModal, { children: [_jsx(Close, { onClick: handleClick, children: _jsx(Icon, { color: colorButtonClose || '--text-link', name: "close", size: "30px", alt: "\u00CDcone de indica\u00E7\u00E3o de checagem negativa. S\u00EDmbolo do algarismo x\u00EDs." }) }), _jsx(ContentWrapperModal, { children: children })] }) }) }));
};
export default forwardRef(DropModal);
//# sourceMappingURL=DropModal.js.map